module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-he.dd490458.png";